module.exports = __webpack_public_path__ + "static/img/dj1-3.eef9622.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/dj1-3.png
// module id = 788
// module chunks = 0